import { InterviewStatus } from '@bosmart/types'

interface ReadyOverlayProps {
  hasLiveService: boolean
  hasError: boolean
  status: InterviewStatus
  onStart: () => void
}

export function ReadyOverlay({ hasLiveService, hasError, status, onStart }: ReadyOverlayProps) {
  if (hasLiveService || hasError || status === InterviewStatus.ENDED) return null

  return (
    <div className="absolute inset-0 flex items-center justify-center bg-black/60 backdrop-blur-sm z-30">
      <div className="text-center p-8 bg-dark-800 rounded-2xl border border-brand-500/20 shadow-2xl max-w-md mx-4">
        <h2 className="text-2xl font-bold text-white mb-2">Ready for BO-SMART AI?</h2>
        <p className="text-gray-400 mb-8">
          The interviewer will ask you a series of technical and behavioral questions.
        </p>
        <button
          onClick={onStart}
          className="px-8 py-3 bg-brand-600 hover:bg-brand-500 text-white rounded-xl font-semibold transition-all shadow-lg hover:shadow-brand-500/25 flex items-center gap-2 mx-auto"
        >
          Start Interview
        </button>
      </div>
    </div>
  )
}
